// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__yqLuk","buttons":"RemoveExpirationActionButtons_buttons__1XTIJ"};